<template>
  <AppHeaderDropdown right no-caret>
    
    
<!-- 
    <template>
       <ul  class="navbar-nav ml-auto">
        <li  class="nav-item b-nav-dropdown dropdown">
          <a target="_self" href="#" class="nav-link dropdown-toggle" id="__BVID__13__BV_button_">
            aaa
          </a>
          <ul tabindex="-1" class="dropdown-menu dropdown-menu-right" aria-labelledby="__BVID__13__BV_button_">
            <li>
              <div role="heading" class="dropdown-header text-center">
                <strong>Conta</strong>
              </div>
            </li>
            <li>
              <a role="menuitem" target="_self" href="#" class="dropdown-item">
                <i class="fa fa-briefcase"></i>Provedor de Assinatura
              </a>
            </li>
            <li>
              <a role="menuitem" target="_self" tabindex="-1" aria-disabled="true" href="#" class="dropdown-item disabled">
                <i class="fa fa-user"></i>65415708090
              </a>
            </li>
            <li>
              <a role="menuitem" target="_self" href="#" class="dropdown-item">
                <i class="fa fa-lock"></i>Sair
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </template> -->





    <template slot="header">
      <img
        src="img/avatars/9.jpg"
        class="img-avatar"
        alt="admin@bootstrapmaster.com" />
    </template>\
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center"><strong>Conta</strong></b-dropdown-header>
      <b-dropdown-item v-if="isAllowed('has_corporation')" @click="showSelectCorporation" :disabled="selectCorporationDisabled"><i class="fa fa-briefcase" />{{corporationSelected && corporationSelected.name}}</b-dropdown-item>
      <b-dropdown-item disabled><i class="fa fa-user" />{{username}}</b-dropdown-item>
      <b-dropdown-item @click="logout"><i class="fa fa-lock" />Sair</b-dropdown-item>
      <b-modal
        id="modal-select-corporation"
        ref="corporationModal"
        hide-footer hide-header
      >
        <h2>Corporações disponíveis</h2>
        <p class="text-muted">Selecione a corporação desejada</p>
        <div class="input-group input-group-sm search-area">
          <input class="form-control input-txt" id="txt-search" type="text" name="txt-search" v-model="searchValue">
          <span class="input-group-append">
            <button id="btn-search" class="btn btn-secondary" type="button" disabled><i class="fa fa-search"></i></button>
          </span>
        </div>
        <br>
        <b-list-group>
          <b-list-group-item button 
            v-for="(itm, idx) in filteredCorporationList" 
            v-bind:key="itm.id" 
            @click="handleSelectCorporation(idx)"
            :disabled="corporationSelected && itm.id == corporationSelected.id"
          >{{itm.name}}</b-list-group-item>
        </b-list-group>
      </b-modal>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import axios from 'axios'
import { requestError, env, isAllowed } from '@/shared/utils'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { 
      username: localStorage.username,
      searchValue: ""
    }
  },
  computed: {
    ...mapState(['corporationList', 'corporationSelected']),
    selectCorporationDisabled: function() {
      return !(this.corporationList && this.corporationList.length > 1)
    },
    filteredCorporationList: function() {
      if (this.searchValue) {
        var regex = new RegExp(this.searchValue, "ig");
        return this.corporationList.filter((itm) => itm.name.match(regex) || itm.cnpj.match(regex));
      }
      return this.corporationList;
    }
  },
  methods: {
    ...mapActions(['setCorporationSelected']),
    logout() {
      var _this = this;
      axios
        .delete(`${env.urlBillingApi}/auth`)
        .then(function(response) {
          localStorage.removeItem('access_token');
          localStorage.removeItem('username');
          localStorage.removeItem('client_id');
          localStorage.removeItem('corporation');
          localStorage.removeItem('corporations');
          localStorage.removeItem('roles');
          window.location.href = '/#/pages/login';
        })
        .catch(function(error) {
          console.error(error.response);
          alert(error.response.data.detail.status);
        });
    },
    isAllowed(role) {
      return isAllowed(role);
    },
    showSelectCorporation() {
      if (!this.selectCorporationDisabled) {
        this.$refs.corporationModal.show();
      }
    },
    handleSelectCorporation(idx) {
      var _this = this;
      axios
        .put(`${env.urlBillingApi}/auth`, [{ corporationId : this.filteredCorporationList[idx].id }])
        .then((response) => {
          _this.setCorporationSelected(_this.filteredCorporationList[idx]);
          _this.$nextTick(() => {
            _this.searchValue = "";
            _this.$refs.corporationModal.hide();
          });
        }).catch((error) => {
          requestError(error);
        });
    }
  }
}
</script>
<style lang="scss" scoped>
.input-txt {
  height: 32px;
}
.img-avatar {
  margin: 0px !important;
  height: 35px;
}
a:hover {
  border-radius: 50%;
}
</style>